import type { Lang } from "@/i18n";
import { navigate } from "@/router";

// Switches language. `targets` gives the path to go to for each language
// (callers pass language-specific slugs / preserved query strings).
export function LangToggle({ lang, targets }: { lang: Lang; targets: Record<Lang, string> }) {
  function go(next: Lang) {
    try {
      localStorage.setItem("lang", next);
    } catch {
      /* ignore */
    }
    navigate(targets[next]);
  }

  return (
    <div className="inline-flex rounded-md border text-sm">
      {(["en", "fr"] as Lang[]).map((l, i) => (
        <button
          key={l}
          onClick={() => go(l)}
          aria-pressed={lang === l}
          className={`px-3 py-1.5 uppercase ${i === 0 ? "rounded-l-md" : "rounded-r-md"} ${
            lang === l ? "bg-primary text-primary-foreground" : "hover:bg-accent"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
